import {fetchProducts} from './thunks';
import createGenericSlice from '../createGenericSlice';
import {slicesNames} from '../constants';

export const productSlice = createGenericSlice({
    name: slicesNames.products,
    initialState: {
        data: {
            products: [],
            page: {
                from: 0,
                size: 20,
                total: 0,
            },
        },
        statuses: {},
        errors: {},
        lastRequestId: {},
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchProducts.fulfilled, (state, {payload}) => {
            if (payload) state.data = payload;
        });
    },
});

export const {resetSlice} = productSlice.actions;
